import { HTTP } from '../../http-common'

export default {
  state: {
    loadedWaterBoxes: []
  },
  getters: {
    loadedWaterBoxes (state) {
      return state.loadedWaterBoxes
    }
  },
  mutations: {
    setLoadedWaterBoxes (state, payload) {
      state.loadedWaterBoxes = payload
    },
    createWaterBox (state, payload) {
      state.loadedWaterBoxes.push(payload)
    },
    updateWaterBox (state, payload) {
      state.loadedWaterBoxes = state.loadedWaterBoxes.map(waterBox => waterBox.id === payload.id ? payload : waterBox)
    },
    removeWaterBox (state, id) {
      state.loadedWaterBoxes = state.loadedWaterBoxes.filter(waterBox => {
        return waterBox.id !== id
      })
    },
    clearLoadedWaterBoxes (state) {
      state.loadedWaterBoxes = []
    }
  },
  actions: {
    loadWaterBoxes ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedWaterBoxes', [])

      return new Promise((resolve, reject) => {
        HTTP.get('water_box_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedWaterBoxes', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createWaterBox ({ commit, getters }, payload) {
      console.log('createWaterBox')
      commit('clearError')
      commit('setLoading', true)
      const newWaterBox = {
        description: payload.description,
        capacity: payload.capacity
      }
      return new Promise((resolve, reject) => {
        HTTP.post('water_box_type.json/', newWaterBox)
          .then(result => {
            console.log(result)
            commit('createWaterBox', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateWaterBox ({ commit, getters }, payload) {
      console.log('updateWaterBox')
      commit('clearError')
      commit('setLoading', true)
      const waterBox = {
        description: payload.description,
        capacity: payload.capacity
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`water_box_type.json/${payload.id}/`, waterBox)
          .then(result => {
            console.log(result)
            commit('updateWaterBox', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeWaterBox ({ commit }, payload) {
      console.log('removeWaterBox')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`water_box_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeWaterBox', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedWaterBoxes ({ commit }) {
      commit('clearLoadedWaterBoxes')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/water_box/index.js